export const ROUTES = {
  DASHBOARD: "/admin",
  ACCOUNT: "/account",
  ONBOARDING: "/onboarding",
  CLUB: {
    DASHBOARD: "/club/dashboard",
  },
  ADMIN: {
    HOME: "/admin",
    MATCHES: {
      LIST: "/admin/match",
      CREATE: "/admin/match/create",
      DETAIL: "/admin/match/:id",
      EDITOR: "/admin/match/:id/editor",
      ANALYTICS: "/admin/match/:id/analytics",
      PLAYER_ANALYTICS: "/admin/match/:id/player-analytics",
      DISPLAY: "/admin/match/:id/display",
      REPORT: "/admin/match/:id/report",
      REPORT_EDIT: "/admin/match/:id/report/edit",
      SQUAD: "/admin/match/:id/squad/:side",
      COACH_REVIEW: (id: string) => `/admin/match/${id}/coach-review`,
      COACH_REVIEW_PLAY: (id: string) => `/admin/match/${id}/coach-review/play`,
      COACH_REVIEW_FEEDBACK: (id: string) => `/admin/match/${id}/coach-review/feedback`,
      TELESTRATION: (id: string) => `/admin/match/${id}/telestration`,
    },
    TAGS: {
      LIST: "/admin/tag",
      CREATE: "/admin/tag/create",
      EDIT: "/admin/tag/:id/edit",
    },
    SPORTS: {
      LIST: "/admin/sport",
      CREATE: "/admin/sport/create",
      DETAIL: "/admin/sport/:id",
      EDIT: "/admin/sport/:id/edit",
    },
    CLUBS: {
      LIST: "/admin/club",
      CREATE: "/admin/club/create",
      DETAIL: "/admin/club/:id",
      EDIT: "/admin/club/:id/edit",
    },
    ROLE_TYPES: {
      LIST: "/admin/role-type",
      CREATE: "/admin/role-type/create",
      EDIT: "/admin/role-type/:id/edit",
    },
    COMPETITIONS: {
      LIST: "/admin/competition",
      CREATE: "/admin/competition/create",
      EDIT: "/admin/competition/:id/edit",
    },
    SEASONS: {
      LIST: "/admin/season",
      CREATE: "/admin/season/create",
      EDIT: "/admin/season/:id/edit",
    },
    TEAMS: {
      LIST: "/admin/team",
      CREATE: "/admin/team/create",
      EDIT: "/admin/team/:id/edit",
      DETAIL: "/admin/team/:id",
    },
    PLAYERS: {
      LIST: "/admin/player",
      CREATE: "/admin/player/create",
      EDIT: "/admin/player/:id/edit",
      DETAIL: "/admin/player/:id",
    },
    REGISTRATIONS: {
      LIST: "/admin/registration",
    },
    CONFIG: "/admin/config",
    TEAM_EVENTS: {
      LIST: "/admin/team-event",
      CREATE: "/admin/team-event/create",
      DETAIL: "/admin/team-event/:id",
      EDIT: "/admin/team-event/:id/edit",
      // FE-20 links here; the page itself is FE-21's broadcast composer.
      BROADCAST_NEW: (id: string) => `/admin/team-event/${id}/broadcast/new`,
      // FE-22's minimal detail stub (subject/status + Cancel) — FE-23 owns
      // the real broadcasts list + detail page and may move this to a flat
      // `/admin/broadcasts/:id` route once it exists; this nested path was
      // chosen so the stub page always has `eventId` on hand for its own
      // `GET .../broadcasts` list-and-find fallback (see that route's
      // docblock in `api/team-broadcast/index.ts`).
      BROADCAST_DETAIL: (eventId: string, broadcastId: string) =>
        `/admin/team-event/${eventId}/broadcast/${broadcastId}`,
    },
    // Team Workspace FE-03 — placeholder routes today, real screens land in
    // the tasks named in each page's "Coming in task X" copy.
    BROADCASTS: "/admin/broadcasts",
    ATTENDANCE: "/admin/attendance",
    PLAYERS_CONTACTS: "/admin/players-contacts",
    PROGRAMME_LOGISTICS: "/admin/programme-logistics",
    SENT_REVIEWS: {
      LIST: "/admin/sent-reviews",
      // GAP-08 (FE-54) — read-only detail of exactly what was sent in one
      // published version, distinct from the live editable draft workspace
      // (`ADMIN.MATCHES.COACH_REVIEW`).
      VERSION: (versionId: string) => `/admin/sent-reviews/${versionId}`,
    },
    TEAM_AVAILABILITY: "/admin/team-availability",
  },
  PLAYER: {
    DASHBOARD: "/player/dashboard",
    PROFILE: "/player/profile",
    MATCHES: "/player/matches",
    CLIPS: "/player/clips",
    TEAM_EVENTS: {
      LIST: "/player/team-events",
      DETAIL: "/player/team-events/:id",
    },
    // Team Workspace FE-03 — placeholder routes, see admin block above.
    MESSAGES: "/player/messages",
    // FE-37 owns the list + `[deliveryId]` detail page (not built yet as of
    // FE-30); FE-30's coach-review dashboard card links straight to
    // `DETAIL` ahead of that page existing, same forward-reference pattern
    // `ADMIN.TEAM_EVENTS.BROADCAST_NEW`/`BROADCAST_DETAIL` used for FE-20/22.
    COACH_FEEDBACK: {
      LIST: "/player/coach-feedback",
      DETAIL: (deliveryId: string) => `/player/coach-feedback/${deliveryId}`,
    },
    // FE-32 owns this page (not built yet as of FE-30); FE-30's team-update
    // dashboard card links straight to it ahead of that page existing.
    TEAM_UPDATES: {
      DETAIL: (broadcastId: string) => `/player/team-updates/${broadcastId}`,
    },
  },
  // Public player profile (outside protected/auth groups)
  PUBLIC_PLAYER: "/p/:slug",
};
